// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7ff37a7e","455":"dd257cc3","977":"002546ef"}[chunkId] + ".chunk.js";
};